import { Routes } from '@angular/router';
import { Dashboard } from './pages/dashboard/dashboard';
import { SimulationInfo } from './pages/simulation-info/simulation-info';
import { RebuyingPeriod } from './pages/rebuying-period/rebuying-period';
import { SpecialCampaigns } from './pages/special-campaigns/special-campaigns';
import { Reports } from './pages/reports/reports';
import { ReportsDealer } from './pages/reports/dealer/dealer';
import { ReportsComission } from './pages/reports/comission/comission';
// import { ReportsNfs } from './pages/reports/nfs/nfs'; // Comentado para desabilitar acesso direto temporariamente
import { ReportsLeads } from './pages/reports/leads/leads';
import { InsuranceServices } from './pages/insurance-services/insurance-services';
import { LeadsHistory } from './pages/leads-history/leads-history';
import { ApprovedProposals } from './pages/approved-proposals/approved-proposals';
import { LeadsDetails } from './pages/leads/leads-info/leads-details';
import { LeadsNavigation } from './pages/leads/leads-navigation/leads-navigation';
import { LeadsOffers } from './pages/leads/leads-offers/leads-offers';
import { LeadsHistoryInfo } from './pages/leads/leads-history-info/leads-history-info';
import { CalendarNavigation } from './pages/calendars/calendar-navigation/calendar-navigation';
import { DayCalendar } from './pages/calendars/day-calendar/day-calendar';
import { MonthCalendar } from './pages/calendars/month-calendar/month-calendar';
import { WeekCalendar } from './pages/calendars/week-calendar/week-calendar';
import { OauthDigitalIntegration } from './components/integration-digital/oauth/oauth';
import { LeadSimulationDigitalIntegration } from './components/integration-digital/lead-simulation/lead-simulation';
import { RedirectionPage } from './pages/redirection-page/redirection-page';
import { AdminPanel } from './pages/admin-panel/admin-panel';
import { LoginPage } from './pages/login-page/login-page';
import { ssoAuthGuard } from './guards/sso-auth.guard';
import { phase2Guard } from './guards/phase2.guard';
import { adminPanelAccessGuard } from './guards/admin-panel-access.guard';
import { SignDriveComponent } from './pages/sign-drive/sign-drive.component';
import { SubscriptionRenew } from './pages/subscription-renew/subscription-renew';
import { DocumentacaoApiPage } from './pages/documentacao-api/documentacao-api.component';
import { ReportSimulator } from './pages/reports/simulator/simulator';
import { QuotasComponent } from './pages/quotas/quotas.component';

export const routes: Routes = [
  { path: 'documentacao-api', component: DocumentacaoApiPage, pathMatch: 'full' },
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: LoginPage },
  { path: 'oauth', component: OauthDigitalIntegration },
  { path: 'lead-simulation', component: LeadSimulationDigitalIntegration, canActivate: [ssoAuthGuard] },
  { path: 'dashboard', component: Dashboard, canActivate: [ssoAuthGuard] },
  { path: 'simulations', component: SimulationInfo, canActivate: [ssoAuthGuard] },
  { path: 'sign-drive', component: SignDriveComponent, canActivate: [ssoAuthGuard] },
  { path: 'subscription-renew', component: SubscriptionRenew, canActivate: [ssoAuthGuard] },
  { path: 'rebuying', component: RebuyingPeriod, canActivate: [ssoAuthGuard] },
  { path: 'approved-proposals', component: ApprovedProposals, canActivate: [ssoAuthGuard] },
  { path: 'campaigns', component: SpecialCampaigns, canActivate: [ssoAuthGuard, phase2Guard] },
  { path: 'quotas', component: QuotasComponent, canActivate: [ssoAuthGuard, phase2Guard] },
  {
    path: 'reports',
    component: Reports,
    canActivate: [ssoAuthGuard, phase2Guard],
    canActivateChild: [ssoAuthGuard],
    children: [
      { path: 'dealer', component: ReportsDealer },
      { path: 'comission', component: ReportsComission },
      { path: 'simulator', component: ReportSimulator },
      { path: 'leads', component: ReportsLeads },
      // { path: 'nfs', component: ReportsNfs }, // Comentado para desabilitar acesso direto temporariamente
      { path: 'leads', component: ReportsLeads }
    ]
  },
  { path: 'insurance-services', component: InsuranceServices, canActivate: [ssoAuthGuard, phase2Guard] },
  { path: 'leads-history', component: LeadsHistory, canActivate: [ssoAuthGuard] },
  {
    path: 'leads',
    component: LeadsNavigation,
    canActivate: [ssoAuthGuard],
    canActivateChild: [ssoAuthGuard],
    children: [
      { path: ':leadId/detalhes', component: LeadsDetails },
      { path: ':leadId/leads-offers', component: LeadsOffers },
      { path: ':leadId/leads-history', component: LeadsHistoryInfo },
      // Manter compatibilidade com rotas antigas
      { path: 'leads-info', component: LeadsDetails },
      { path: 'leads-offers', component: LeadsOffers },
      { path: 'leads-history', component: LeadsHistoryInfo },
      { path: '', redirectTo: 'leads-info', pathMatch: 'full' }
    ],

  },
  {
    path: 'calendar',
    component: CalendarNavigation,
    canActivate: [ssoAuthGuard],
    canActivateChild: [ssoAuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'day',
        pathMatch: 'full'
      },
      {
        path: 'day',
        component: DayCalendar // Componente de calendário diário
      },
      {
        path: 'week',
        component: WeekCalendar // Componente de calendário semanal
      },
      {
        path: 'month',
        component: MonthCalendar // Componente de calendário mensal
      }
    ]
  },
  {
    path: 'error',
    component: RedirectionPage,
    canActivate: [ssoAuthGuard]
  },
  {
    path: 'admin-panel',
    component: AdminPanel,
    canActivate: [ssoAuthGuard, phase2Guard, adminPanelAccessGuard]
  },
  {
    path: '**',
    component: OauthDigitalIntegration,
    canActivate: [ssoAuthGuard]
  }
];
